import PropTypes from 'prop-types';
import ClassNames from 'classnames';
import { CurrencyInputComponent } from '../../../index';

function IncomeInputComponent(props) {
  const {
    name,
    id,
    label,
    className,
    errors,
    readOnly,
    autoFocus,
    period,
    amount,
    onAmountChangeHandler,
    onPeriodChangeHandler,
    onBlurHandler,
  } = props;

  const classNames = ClassNames('input-field-with-switch', className, {
    'has-content': amount !== null,
  });

  return (
    <CurrencyInputComponent
      autoFocus={autoFocus}
      readOnly={readOnly}
      label={label}
      name={name}
      id={id}
      onChangeHandler={onAmountChangeHandler}
      onBlurHandler={onBlurHandler}
      value={amount}
      className={classNames}
      errors={errors}
    >
      <div className="switch">
        <input
          onChange={onPeriodChangeHandler}
          value="monthly"
          type="radio"
          id={`${id}-0`}
          name={`radio-${id}`}
          checked={period !== 'yearly'}
        />
        <label htmlFor={`${id}-0`}>Per<br />maand</label>
      </div>
      <div className="switch last-child">
        <input
          onChange={onPeriodChangeHandler}
          value="yearly"
          type="radio"
          id={`${id}-1`}
          name={`radio-${id}`}
          checked={period === 'yearly'}
        />
        <label htmlFor={`${id}-1`}>Per<br />jaar</label>
      </div>
    </CurrencyInputComponent>
  );
}

IncomeInputComponent.propTypes = {
  autoFocus: PropTypes.bool,
  label: PropTypes.string.isRequired,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  id: PropTypes.string,
  className: PropTypes.string,
  onPeriodChangeHandler: PropTypes.func,
  onAmountChangeHandler: PropTypes.func,
  onBlurHandler: PropTypes.func,
  amount: PropTypes.number,
  period: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
};

IncomeInputComponent.defaultProps = {
  autoFocus: false,
  className: null,
  name: null,
  readOnly: false,
  amount: null,
  period: 'yearly',
  id: null,
  onPeriodChangeHandler: () => {},
  onAmountChangeHandler: () => {},
  onBlurHandler: () => {},
  errors: null,
};

export default IncomeInputComponent;
